import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ScheduleasRecurringMeasurementModal from '../../../components/modal/ScheduleasRecurringMeasurement.modal'
import EditRecurringModal from '../../../components/modal/EditRecurringModal'
import Icon from '../../../components/icons'
import Text from '../../../elements/Typo/Text'
import { trackEvent } from '../../../_common/functions'
import { EXPERIMENT_TYPES } from '../../../_common/constant'

interface Props {
    experiment: any
    iconButton?: boolean
    ownerAccess?: boolean
}

const RecurringMeasurementButton: React.FC<Props> = ({ experiment, iconButton = false, ownerAccess = false }) => {
    const { t } = useTranslation()
    const [recurringModal, setRecurringModal] = useState<boolean>(false)
    const [editRecurringModal, setEditRecurringModal] = useState<boolean>(false)
    const [showRecurringButton, setShowRecurringButton] = useState<boolean>(false)
    const [isWeeklyExperiment, setIsWeeklyExperiment] = useState<boolean>(false)
    //const isAfter = moment().isAfter(moment(experiment?.end_date))

    useEffect(() => {
        const is_mte = experiment?.experiment_type?.title === EXPERIMENT_TYPES.MTE.title
        const is_dml = experiment?.experiment_type?.title === EXPERIMENT_TYPES.DML.title
        if (experiment?.is_sdk != 1 && !is_mte && !is_dml && (experiment?.parent_experiment_id == null || experiment?.parent_experiment_id == 0) && ownerAccess) {
            setShowRecurringButton(true)
        } else if (experiment.schedule_parent_experiment) {
            setShowRecurringButton(true)
        } else {
            setShowRecurringButton(false)
        }

        if (experiment?.experiment_metadatas?.measurement_column_map?.date_frequency?.toLowerCase() == 'weekly') {
            setIsWeeklyExperiment(true)
        } else {
            setIsWeeklyExperiment(false)
        }
    }, [experiment])

    return (
        <>
            {showRecurringButton && (
                <button
                    type="button"
                    onClick={() => {
                        if (experiment.is_scheduled || experiment.schedule_parent_experiment) {
                            trackEvent('experiment_details_edit_recurring_clicked', { experiment_literal: experiment?.experiment_literal })
                            setEditRecurringModal(true)
                        } else {
                            trackEvent('experiment_details_create_recurring_clicked', { experiment_literal: experiment?.experiment_literal })
                            setRecurringModal(true)
                        }
                    }}
                    disabled={isWeeklyExperiment}
                    title={isWeeklyExperiment ? t("This experiment can't be set as recurring because it uses Weekly Granularity data, which is currently not supported for Recurring Experiments.") : ''}
                    className="flex gap-[0.33rem] bg-[#FFF] items-center"
                >
                    <div className={`h-[1.182rem] w-[1.182rem] rounded-[1.045rem] flex items-center justify-center ${isWeeklyExperiment ? 'bg-gray-200 text-gray-400' : 'bg-primary'}`}>
                        <Icon name="recurring-expt" size={'0.545rem'}></Icon>
                    </div>
                    <Text size="xs" className={`!text-[0.591rem] !font-semibold whitespace-nowrap ${isWeeklyExperiment ? 'text-gray-400' : 'text-black'}`}>
                        {experiment.is_scheduled || experiment.schedule_parent_experiment ? t('Edit Recurring') : t('Create Recurring')} {}
                    </Text>
                </button>
            )}
            {recurringModal && (
                <ScheduleasRecurringMeasurementModal
                    isModalOpen={recurringModal}
                    onClose={() => {
                        setRecurringModal(false)
                    }}
                    experiment={experiment}
                />
            )}

            {editRecurringModal && (
                <EditRecurringModal
                    isModalOpen={editRecurringModal}
                    onClose={() => {
                        setEditRecurringModal(false)
                    }}
                    experiment={experiment}
                />
            )}
        </>
    )
}

export default RecurringMeasurementButton
